import applicationRoutes from '../src/routes/applicationRoutes';
export default {
    formDetail: {
        path: '/form/detail',
        name: 'form-detail',
        component: () => import('@/views/form/form-detail.vue')
    },
    application: {
        application: Object.assign({}, applicationRoutes.infoPath, { children: [
                ...applicationRoutes.infoChildren,
                {
                    path: 'testApplication/:schemaCode',
                    name: 'testApplication',
                    component: () => import('./views/application-list.vue')
                },
                {
                    path: "custom-list",
                    name: "customList",
                    component: () => import("./views/custom-list/index.vue"),
                },
            ] })
    },
};
